import styled from 'styled-components';

import { GalleryGrid, FlatList } from '../../components';

export const Home = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	max-width: 100vw;
	background-color: #FFF;
	box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.04);
	border-radius: 16px;
	margin-top: 48px;

	@media screen and (max-width: 601px) {
		margin: 0 auto;
		border-radius: 0;
	}
`;

Home.FlatList = FlatList;

Home.Header = styled.header`
	display: flex;
	flex-direction: column;
`;

Home.BackgroundImage = styled.img`
	width: 100%;
	object-fit: cover;
	height: 140px !important;
	border-radius: 16px 16px 0px 0px;

	@media screen and (max-width: 601px) {
		border-radius: 0;
	}
`;

Home.CompanyInfoRow = styled.div`
	display: flex;
	flex-direction: column;
	padding: 16px;
`;

Home.BodyContainer = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.04);
	border-radius: 16px;
`;

Home.BodyContainer.Card = styled.div`
	display: flex;
	flex-direction: column;
	border-radius: 0 !important;
`;

Home.GalleryGrid = GalleryGrid;

Home.BodyContainer.Card.Title = styled.div`
	font-weight: 500;
	font-size: 16px;
	line-height: 20px;
	color: #26282A;
`;

Home.BodyContainer.Card.ContentWrap = styled.div`
	display: flex;
	flex-wrap: wrap;
`;

Home.BodyContainer.Card.Content = styled.div`
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	color: #4E5255;
	margin-top: 8px;
`;

Home.CompanyInfoRow.AvatarContainer = styled.div`
	position: relative;
	margin-bottom: 18px;
`;

Home.CompanyInfoRow.Avatar = styled.img`
	object-fit: cover;
	width: 72px !important;
	height: 72px !important;
	margin-bottom: 18px;
	position: absolute;
	bottom: -30px;
`;

Home.CompanyInfoRow.Content = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`;

Home.CompanyInfoRow.Content.Title = styled.div`
	font-weight: 500;
	font-size: 20px;
	line-height: 24px;
	color: #26282A;
`;

Home.CompanyInfoRow.Content.Address = styled.div`
	font-style: normal;
	font-weight: 400;
	font-size: 12px;
	line-height: 16px;
	color: #4E5255;
`;

Home.CompanyInfoRow.Content.Specialty = styled.div`
	font-weight: 400;
	font-size: 12px;
	line-height: 16px;
	color: #4E5255;
`;
